import { createPendingTiming } from "./timingCore";
import { APP_KPI_NAME } from "./utils";

export interface InquiryContext {
  module: string;
  screen: string;
  action: string;
  entityType: string;
  role?: string;
  entityId?: string;
}

function buildProperties(
  context: InquiryContext,
  durationMs: number,
  success: boolean,
  errorMessage?: string,
) {
  return {
    module: context.module,
    screen: context.screen,
    action: context.action,
    entityType: context.entityType,
    role: context.role ?? "",
    entityId: context.entityId ?? "",
    success,
    durationMs,
    ...(errorMessage ? { errorMessage } : {}),
  };
}

const inquiryTiming = createPendingTiming<InquiryContext>({
  metricName: APP_KPI_NAME.PCS_INQUIRY,
  completedEventName: "pcs_inquiry_completed",
  failedEventName: "pcs_inquiry_failed",
  buildProperties,
});

export function trackInquiryCompleted(context: InquiryContext, startedAt: number) {
  inquiryTiming.trackCompleted(context, startedAt);
}

export function trackInquiryFailed(context: InquiryContext, startedAt: number, error: unknown) {
  inquiryTiming.trackFailed(context, startedAt, error);
}

export function startInquiryTiming(id: string, context: InquiryContext) {
  inquiryTiming.start(id, context);
}

export function completeInquiryTiming(id: string): boolean {
  return inquiryTiming.complete(id);
}

export function failInquiryTiming(id: string, error: unknown): boolean {
  return inquiryTiming.fail(id, error);
}

export function hasPendingInquiry(id: string): boolean {
  return inquiryTiming.has(id);
}

export function clearInquiryTiming(id: string) {
  inquiryTiming.clear(id);
}
